import React from 'react';
import './GameText.css';

// The game writes element icons into spell text as `<sprite name="feu">`; the
// names are French in every language. Each maps to its characteristic's icon.
const SPRITE_ICONS = {
    terre: '/img/stat_force.png',
    feu: '/img/stat_intelligence.png',
    eau: '/img/stat_chance.png',
    air: '/img/stat_agilite.png',
};
const SPRITE_RE = /<sprite name="([^"]*)"\s*\/?>/g;

/** Game description text, with its sprite tags drawn as icons (unknown ones dropped). */
const GameText = ({ text }) => {
    const parts = String(text).split(SPRITE_RE);
    // split() alternates text and captured sprite names.
    return parts.map((part, i) => {
        if (i % 2 === 0) return part;
        const src = SPRITE_ICONS[part];
        return src ? <img key={i} src={src} alt={part} className="game-text-sprite" /> : null;
    });
};

export default GameText;
